import z from 'zod';

export enum TradeStatus {
  OPEN = 'open',
  CLOSED = 'closed',
  STOPLOSS = 'stoploss',
  TAKEPROFIT = 'takeprofit',
}

export const tradeStatusSchema = z.enum(TradeStatus);
